export const Interco = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7334 6.1246L11.4671 4.39091L9.7334 2.65721"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53227 7.8583C4.53227 6.93869 4.89758 6.05675 5.54785 5.40649C6.19811 4.75622 7.08006 4.39091 7.99967 4.39091H11.4671"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7358 18.0615L14.0021 19.7952L15.7358 21.5289"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9369 16.3278C20.9369 17.2474 20.5716 18.1294 19.9214 18.7796C19.2711 19.4299 18.3892 19.7952 17.4696 19.7952H14.0022"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask id="path-5-inside-1_55_1175" fill="white">
      <rect x="3.72797" y="10.7864" width="7.35767" height="10" rx="1" />
    </mask>
    <rect
      x="3.72797"
      y="10.7864"
      width="7.35767"
      height="10"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#path-5-inside-1_55_1175)"
    />
    <line
      x1="3.3238"
      y1="20.0364"
      x2="11.4898"
      y2="20.0364"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="6.45063"
      y1="13.6754"
      x2="7.73518"
      y2="13.6754"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <line
      x1="7.45783"
      y1="15.6832"
      x2="8.74238"
      y2="15.6832"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M6.45063 17.9284H7.77615"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <mask id="path-10-inside-2_55_1175" fill="white">
      <rect x="14.2397" y="3.21359" width="7.35767" height="10" rx="1" />
    </mask>
    <rect
      x="14.2397"
      y="3.21359"
      width="7.35767"
      height="10"
      rx="1"
      stroke="currentColor"
      strokeWidth="3"
      mask="url(#path-10-inside-2_55_1175)"
    />
    <line
      x1="13.8355"
      y1="12.4636"
      x2="22.0015"
      y2="12.4636"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="16.9623"
      y1="6.1026"
      x2="18.2469"
      y2="6.1026"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <line
      x1="17.9696"
      y1="8.11043"
      x2="19.2541"
      y2="8.11043"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M16.9623 10.3556H18.2879"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
